import { render, staticRenderFns } from "./FeedbackStats.vue?vue&type=template&id=3d5c5bd7&"
import script from "./FeedbackStats.vue?vue&type=script&lang=js&"
export * from "./FeedbackStats.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports